//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ICollectionServiceProxy {
    /**
     * Creación de nueva colección
     * @param storeId ID de la tienda
     * @return Id de la colección creada
     */
    create(storeId: string, body: CreateCollectionDto): Observable<CreateCollectionResponse>;
    /**
     * Listado de colecciones asociadas a una Tienda
     * @param status (optional) Estado de la colección
     * @param name (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @return Lista de productos
     */
    findAll(storeId: string, status?: boolean | undefined, name?: string | undefined, page?: number | undefined, size?: number | undefined): Observable<ListCollectionResponseDto>;
    /**
     * Deshabilitar Colecciones
     * @return Deshabilitar Colecciones
     */
    disable(storeId: string, body: string[]): Observable<void>;
    /**
     * Habilitar Colecciones
     * @return Habilitar Colecciones
     */
    enable(storeId: string, body: string[]): Observable<void>;
    /**
     * Obtener una colección específica por ID
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @return Detalles de la colección
     */
    findOne(storeId: string, id: string): Observable<CollectionDto>;
    /**
     * Actualización de una colección existente
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @return Colección actualizada
     */
    update(storeId: string, id: string, body: UpdateCollectionDto): Observable<void>;
    /**
     * Eliminar una colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @return Colección eliminada
     */
    remove(storeId: string, id: string): Observable<void>;
    /**
     * Agregar productos a una Colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @return Productos agregados
     */
    addProducts(storeId: string, id: string, body: string[]): Observable<void>;
    /**
     * Listado de productos asociados a una colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @param sort (optional) 
     * @param name (optional) 
     * @return Lista de productos
     */
    findAllProducts(storeId: string, id: string, page: number, size: number, sort?: string | undefined, name?: string | undefined): Observable<ListCollectionProductResponseDto>;
    /**
     * Quitar producto a una Colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @param idProduct ID del producto
     * @return Producto removido
     */
    removeProducts(storeId: string, id: string, idProduct: string): Observable<void>;
    /**
     * Exportar Excel con productos asociados a una colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @param to (optional) Destinatarios
     * @return Excel de productos asociados a una coleccion
     */
    exportProductsToExcel(storeId: string, id: string, to?: string[] | undefined): Observable<FileExportDto>;
    /**
     * Exportar Csv con productos asociados a una colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @param to (optional) Destinatarios
     * @return Csv de productos asociados a una coleccion
     */
    exportProductsToCsv(storeId: string, id: string, to?: string[] | undefined): Observable<FileExportDto>;
    /**
     * Importar productos de una colección desde Excel
     */
    collectionController_importCollectionProductsFromExcel(storeId: string, id: string, body: FileImportDto): Observable<void>;
    /**
     * Importar productos de una colección desde Csv
     */
    collectionController_importCollectionProductsFromCsv(storeId: string, id: string, body: FileImportDto): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class CollectionServiceProxy implements ICollectionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Creación de nueva colección
     * @param storeId ID de la tienda
     * @return Id de la colección creada
     */
    create(storeId: string, body: CreateCollectionDto): Observable<CreateCollectionResponse> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCollectionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCollectionResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateCollectionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCollectionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateCollectionResponse>(null as any);
    }

    /**
     * Listado de colecciones asociadas a una Tienda
     * @param status (optional) Estado de la colección
     * @param name (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @return Lista de productos
     */
    findAll(storeId: string, status?: boolean | undefined, name?: string | undefined, page?: number | undefined, size?: number | undefined): Observable<ListCollectionResponseDto> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (status !== null && status !== undefined)
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        else
            url_ = url_.replace("/{status}", "");
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListCollectionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListCollectionResponseDto>;
        }));
    }

    protected processFindAll(response: HttpResponseBase): Observable<ListCollectionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListCollectionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListCollectionResponseDto>(null as any);
    }

    /**
     * Deshabilitar Colecciones
     * @return Deshabilitar Colecciones
     */
    disable(storeId: string, body: string[]): Observable<void> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/disable-collection";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Habilitar Colecciones
     * @return Habilitar Colecciones
     */
    enable(storeId: string, body: string[]): Observable<void> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/enable-collection";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Obtener una colección específica por ID
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @return Detalles de la colección
     */
    findOne(storeId: string, id: string): Observable<CollectionDto> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/{id}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindOne(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindOne(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionDto>;
        }));
    }

    protected processFindOne(response: HttpResponseBase): Observable<CollectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CollectionDto>(null as any);
    }

    /**
     * Actualización de una colección existente
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @return Colección actualizada
     */
    update(storeId: string, id: string, body: UpdateCollectionDto): Observable<void> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/{id}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Eliminar una colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @return Colección eliminada
     */
    remove(storeId: string, id: string): Observable<void> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/{id}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Agregar productos a una Colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @return Productos agregados
     */
    addProducts(storeId: string, id: string, body: string[]): Observable<void> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/{id}/products";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProducts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Listado de productos asociados a una colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @param sort (optional) 
     * @param name (optional) 
     * @return Lista de productos
     */
    findAllProducts(storeId: string, id: string, page: number, size: number, sort?: string | undefined, name?: string | undefined): Observable<ListCollectionProductResponseDto> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/{id}/products?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sort !== null && sort !== undefined)
        url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
        else
            url_ = url_.replace("/{sort}", "");
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === undefined || size === null)
            throw new Error("The parameter 'size' must be defined and cannot be null.");
        else
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAllProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAllProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListCollectionProductResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListCollectionProductResponseDto>;
        }));
    }

    protected processFindAllProducts(response: HttpResponseBase): Observable<ListCollectionProductResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListCollectionProductResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListCollectionProductResponseDto>(null as any);
    }

    /**
     * Quitar producto a una Colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @param idProduct ID del producto
     * @return Producto removido
     */
    removeProducts(storeId: string, id: string, idProduct: string): Observable<void> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/{id}/products/{idProduct}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (idProduct === undefined || idProduct === null)
            throw new Error("The parameter 'idProduct' must be defined.");
        url_ = url_.replace("{idProduct}", encodeURIComponent("" + idProduct));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveProducts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Exportar Excel con productos asociados a una colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @param to (optional) Destinatarios
     * @return Excel de productos asociados a una coleccion
     */
    exportProductsToExcel(storeId: string, id: string, to?: string[] | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/{id}/products/export/excel?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            to && to.forEach(item => { url_ += "to=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProductsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProductsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExportDto>;
        }));
    }

    protected processExportProductsToExcel(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExportDto>(null as any);
    }

    /**
     * Exportar Csv con productos asociados a una colección
     * @param storeId ID de la tienda
     * @param id ID de la colección
     * @param to (optional) Destinatarios
     * @return Csv de productos asociados a una coleccion
     */
    exportProductsToCsv(storeId: string, id: string, to?: string[] | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/{id}/products/export/csv?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            to && to.forEach(item => { url_ += "to=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProductsToCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProductsToCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExportDto>;
        }));
    }

    protected processExportProductsToCsv(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExportDto>(null as any);
    }

    /**
     * Importar productos de una colección desde Excel
     */
    collectionController_importCollectionProductsFromExcel(storeId: string, id: string, body: FileImportDto): Observable<void> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/collections/{id}/import/excel";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollectionController_importCollectionProductsFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollectionController_importCollectionProductsFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCollectionController_importCollectionProductsFromExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Importar productos de una colección desde Csv
     */
    collectionController_importCollectionProductsFromCsv(storeId: string, id: string, body: FileImportDto): Observable<void> {
        let url_ = this.baseUrl + "/management/collection/store/{storeId}/collections/{id}/import/csv";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollectionController_importCollectionProductsFromCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollectionController_importCollectionProductsFromCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCollectionController_importCollectionProductsFromCsv(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

  protected getBaseUrl(defaultUrl: string): string {
    return defaultUrl;
  }
}

export class ImageDto implements IImageDto {
    url!: string;
    name!: string;


    constructor(data?: IImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.url = _data["url"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["url"] = this.url;
        data["name"] = this.name;
        return data;
    }
}

export interface IImageDto {
    url: string;
    name: string;

}

export class CollectionSeoDtoV2 implements ICollectionSeoDtoV2 {
    /** Palabras clave SEO */
    keywords!: string;
    /** Enlace permanente */
    permalink!: string;
    /** Título SEO */
    metaTitle!: string;
    /** Descripción SEO */
    metaDescription!: string;


    constructor(data?: ICollectionSeoDtoV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.keywords = _data["keywords"];
            this.permalink = _data["permalink"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
        }
    }

    static fromJS(data: any): CollectionSeoDtoV2 {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionSeoDtoV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["keywords"] = this.keywords;
        data["permalink"] = this.permalink;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        return data;
    }
}

export interface ICollectionSeoDtoV2 {
    /** Palabras clave SEO */
    keywords: string;
    /** Enlace permanente */
    permalink: string;
    /** Título SEO */
    metaTitle: string;
    /** Descripción SEO */
    metaDescription: string;

}

export class CreateCollectionDto implements ICreateCollectionDto {
    name!: string;
    description!: string;
    image!: ImageDto;
    startDate!: string;
    endDate!: string | undefined;
    seo!: CollectionSeoDtoV2;
    /** Indica si la colección es destacada */
    isFeatured: boolean = false;
    /** Indica si la colección es visible en búsquedas */
    searchable: boolean = false;
collectionType!: CollectionDtoCollectionType.MANUAL;

    constructor(data?: ICreateCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.image = new ImageDto();
            this.seo = new CollectionSeoDtoV2();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.description = _data["description"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : new ImageDto();
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.seo = _data["seo"] ? CollectionSeoDtoV2.fromJS(_data["seo"]) : new CollectionSeoDtoV2();
            this.isFeatured = _data["isFeatured"];
            this.searchable = _data["searchable"];
            this.collectionType = _data["collectionType"] ? _data["collectionType"] : CollectionDtoCollectionType.MANUAL;
        }
    }

    static fromJS(data: any): CreateCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["description"] = this.description;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["seo"] = this.seo ? this.seo.toJSON() : <any>undefined;
        data["isFeatured"] = this.isFeatured;
        data["searchable"] = this.searchable;
        data["collectionType"] = this.collectionType;
        return data;
    }
}

export interface ICreateCollectionDto {
    name: string;
    description: string;
    image: ImageDto;
    startDate: string;
    endDate: string | undefined;
    seo: CollectionSeoDtoV2;
    /** Indica si la colección es destacada */
    isFeatured: boolean;
    /** Indica si la colección es visible en búsquedas */
    searchable: boolean;
    collectionType: CollectionDtoCollectionType.MANUAL;

}

export class CreateCollectionResponse implements ICreateCollectionResponse {
    id!: string;


    constructor(data?: ICreateCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateCollectionResponse {
    id: string;

}
export enum CollectionDtoCollectionType {
    MANUAL = 'MANUAL',
    DINAMICA = 'DINAMICA',
}
export class CollectionDto implements ICollectionDto {
    id!: string;
    name!: string;
    description!: string;
    image!: ImageDto;
    productsCount!: number;
    startDate!: string;
    endDate!: string | undefined;
    seo!: CollectionSeoDtoV2;
    status!: CollectionDtoStatus;
    /** Indica si la colección es destacada */
    isFeatured: boolean = false;
    /** Indica si la colección es visible en búsquedas */
    searchable: boolean = false;
    collectionType!: CollectionDtoCollectionType.MANUAL;


    constructor(data?: ICollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.image = new ImageDto();
            this.seo = new CollectionSeoDtoV2();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : new ImageDto();
            this.productsCount = _data["productsCount"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.seo = _data["seo"] ? CollectionSeoDtoV2.fromJS(_data["seo"]) : new CollectionSeoDtoV2();
            this.status = _data["status"];
            this.isFeatured = _data["isFeatured"];
            this.searchable = _data["searchable"];
            this.collectionType = _data["collectionType"] ? _data["collectionType"] : CollectionDtoCollectionType.MANUAL;
        }
    }

    static fromJS(data: any): CollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["productsCount"] = this.productsCount;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["seo"] = this.seo ? this.seo.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["isFeatured"] = this.isFeatured;
        data["searchable"] = this.searchable;
        data["collectionType"] = this.collectionType;

        return data;
    }
}

export interface ICollectionDto {
    id: string;
    name: string;
    description: string;
    image: ImageDto;
    productsCount: number;
    startDate: string;
    endDate: string | undefined;
    seo: CollectionSeoDtoV2;
    status: CollectionDtoStatus;
    /** Indica si la colección es destacada */
    isFeatured: boolean;
    /** Indica si la colección es visible en búsquedas */
    searchable: boolean;
    collectionType: CollectionDtoCollectionType.MANUAL;

}

export class PageDto implements IPageDto {
    /** Número de página */
    number!: number;
    /** Tamaño de página */
    size!: number;
    /** Total de elementos encontrados */
    totalElements!: number;
    /** Total de páginas segun size y taotalElements */
    totalPages!: number;
    /** Búsqueda vacía */
    empty!: boolean;


    constructor(data?: IPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            this.size = _data["size"];
            this.totalElements = _data["totalElements"];
            this.totalPages = _data["totalPages"];
            this.empty = _data["empty"];
        }
    }

    static fromJS(data: any): PageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        data["size"] = this.size;
        data["totalElements"] = this.totalElements;
        data["totalPages"] = this.totalPages;
        data["empty"] = this.empty;
        return data;
    }
}

export interface IPageDto {
    /** Número de página */
    number: number;
    /** Tamaño de página */
    size: number;
    /** Total de elementos encontrados */
    totalElements: number;
    /** Total de páginas segun size y taotalElements */
    totalPages: number;
    /** Búsqueda vacía */
    empty: boolean;

}

export class ListCollectionResponseDto implements IListCollectionResponseDto {
    /** Paginación */
    page!: PageDto;
    /** Lista de elementos */
    items!: CollectionDto[];


    constructor(data?: IListCollectionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.page = new PageDto();
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"] ? PageDto.fromJS(_data["page"]) : new PageDto();
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CollectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListCollectionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListCollectionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IListCollectionResponseDto {
    /** Paginación */
    page: PageDto;
    /** Lista de elementos */
    items: CollectionDto[];

}

export class UpdateCollectionDto implements IUpdateCollectionDto {
    name!: string;
    description!: string;
    image!: ImageDto;
    startDate!: string;
    endDate!: string | undefined;
    seo!: CollectionSeoDtoV2;
    /** Indica si la colección es destacada */
    isFeatured: boolean = false;
    /** Indica si la colección es visible en búsquedas */
    searchable: boolean = false;
    collectionType!: CollectionDtoCollectionType.MANUAL;


    constructor(data?: IUpdateCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.image = new ImageDto();
            this.seo = new CollectionSeoDtoV2();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.description = _data["description"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : new ImageDto();
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.seo = _data["seo"] ? CollectionSeoDtoV2.fromJS(_data["seo"]) : new CollectionSeoDtoV2();
            this.isFeatured = _data["isFeatured"];
            this.searchable = _data["searchable"];
            this.collectionType = _data["collectionType"] ? _data["collectionType"] : CollectionDtoCollectionType.MANUAL;
        }
    }

    static fromJS(data: any): UpdateCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["description"] = this.description;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["seo"] = this.seo ? this.seo.toJSON() : <any>undefined;
        data["isFeatured"] = this.isFeatured;
        data["searchable"] = this.searchable;
        data["collectionType"] = this.collectionType;
        return data;
    }
}

export interface IUpdateCollectionDto {
    name: string;
    description: string;
    image: ImageDto;
    startDate: string;
    endDate: string | undefined;
    seo: CollectionSeoDtoV2;
    /** Indica si la colección es destacada */
    isFeatured: boolean;
    /** Indica si la colección es visible en búsquedas */
    searchable: boolean;
    collectionType: CollectionDtoCollectionType.MANUAL;

}

export class FileExportDto implements IFileExportDto {
    /** Nombre del archivo, incluyendo extensión */
    fileName!: string;
    /** Contenido del archivo en base64 */
    fileContent!: string;


    constructor(data?: IFileExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
        }
    }

    static fromJS(data: any): FileExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        return data;
    }
}

export interface IFileExportDto {
    /** Nombre del archivo, incluyendo extensión */
    fileName: string;
    /** Contenido del archivo en base64 */
    fileContent: string;

}

export class FileImportDto implements IFileImportDto {
    /** Nombre del archivo, incluyendo extensión */
    fileName!: string;
    /** Contenido del archivo en base64 */
    fileContent!: string;
    /** MIME type del archivo (opcional) */
    mimeType?: string;


    constructor(data?: IFileImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface IFileImportDto {
    /** Nombre del archivo, incluyendo extensión */
    fileName: string;
    /** Contenido del archivo en base64 */
    fileContent: string;
    /** MIME type del archivo (opcional) */
    mimeType?: string;

}

export class CollectionProductDto implements ICollectionProductDto {
    productId!: string;
    name!: string;
    imageUrl!: string;


    constructor(data?: ICollectionProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): CollectionProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface ICollectionProductDto {
    productId: string;
    name: string;
    imageUrl: string;

}

export class ListCollectionProductResponseDto implements IListCollectionProductResponseDto {
    /** Paginación */
    page!: PageDto;
    /** Lista de elementos */
    items!: CollectionProductDto[];


    constructor(data?: IListCollectionProductResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.page = new PageDto();
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"] ? PageDto.fromJS(_data["page"]) : new PageDto();
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CollectionProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListCollectionProductResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListCollectionProductResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IListCollectionProductResponseDto {
    /** Paginación */
    page: PageDto;
    /** Lista de elementos */
    items: CollectionProductDto[];

}

export enum CollectionDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}